import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { UserQuery } from '@core/store/user/user.query';
import { AuthService } from '@zitemedia/zitadel-sso-frontend';
import { AsyncPipe } from '@angular/common';
import { NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AmApiKeyService } from '@core/services/am-api-key.service';
import { PriceRequestInbox } from '@shared/services/price-request-inbox.service';
import { NotificationsModalComponent } from '@shared/modals/notifications/notifications-modal.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgbDropdownModule,
    AsyncPipe,
  ]
})
export class HeaderComponent {
  private readonly _router = inject(Router);
  private readonly userQuery = inject(UserQuery);
  private readonly authService = inject(AuthService);
  private readonly AmApiKeyService = inject(AmApiKeyService);
  private readonly modalService = inject(NgbModal);
  readonly totalCount$ = inject(PriceRequestInbox).totalCount$;

  readonly isMenuOpen = input<boolean>(undefined);
  readonly hideHeader = input<boolean>(undefined);
  readonly toggleMenu = output<void>();

  user = this.userQuery.getUser$;
  authServiceError = false;
  authErrorMessage = '';

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    // Subscribe to auth service error states
    this.authService.authServiceError$.subscribe(error => {
      this.authServiceError = error;
    });

    this.authService.authErrorMessage$.subscribe(message => {
      this.authErrorMessage = message;
    });
  }

  onToggleMenu() {
    this.toggleMenu.emit(undefined);
  }

  onLogin() {
    this._router.navigateByUrl('login');
  }

  async onLogout() {
    try {
      await this.authService.logout();
      this.AmApiKeyService.disable()
    } catch (error) {
    }
  }

  openNotifications(): void {
    this.modalService.open(NotificationsModalComponent, { size: 'sm', centered: true });
  }
}
